// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ge-0";
export var buttonContainer = "_ge-3";
export var cancelButton = "_ge-4";
export var headerSection = "_ge-6";
export var headerTitle = "_ge-9";
export var messageSideLeft = "_ge-1";
export var messageSideRight = "_ge-2";
export var orderNumberContainer = "_ge-7";
export var orderNumberLabel = "_ge-8";
export var submitButton = "_ge-5";